import Header from './Header';
import Layout from 'antd/es/layout';

const AppLayout = ({ children }) => {
  return (
    <Layout className="app-container">
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout className="app-content">
        <Layout.Content>{children}</Layout.Content>
      </Layout>
      {/* <Layout.Footer>
        <Footer />
      </Layout.Footer> */}
    </Layout>
  );
};

export default AppLayout;
